import { GoogleAnalyticService } from '@app/app-initialisers/google-analytics-service/google-analytics.service';

export const GoogleAnalyticServiceInit = (googleAnalyticService: GoogleAnalyticService) => () => googleAnalyticService.googleAnalyticInit();
